import axiosInstance from '../../../api/axiosConfig';
import { AddAgency, Agency } from '../../../types/agency';

export const getAgencies = async () => {
    const response = await axiosInstance.get<Agency[]>('/agency');
    return response?.data;
};

export const createAgency = async (agency: AddAgency) => {
    const response = await axiosInstance.post<Agency>('/agency', agency);
    return response?.data;
};

export const updateAgency = async (agency: Agency) => {
    const response = await axiosInstance.patch<Agency>(`/agency/${agency.id}`, agency);
    return response?.data;
};
